import React from 'react';
import dayjs from 'dayjs';

//跟踪组件是否已挂载。
export const useRefMounted = () => {
	const refMounted = React.useRef(false);

	React.useEffect(() => {
		refMounted.current = true;

		return () => {
			refMounted.current = false;
		};
	}, []);
	return refMounted;
};

export const useStateRef = (init) => {
	const [state, setState] = React.useState(init);

	const stateRef = React.useRef(init);

	const setValue = React.useCallback((value) => {
		if (stateRef.current === value) return;

		stateRef.current = value;

		setState(value);
	}, []);

	return [state, setValue, stateRef.current];
};
//倒计时
export const useCountDown = (overHandler) => {
	const secondRef = React.useRef(0);

	const [second, setSecond] = React.useState(0);

	const [voice, setVoice] = React.useState(false);

	const refMounted = React.useRef(false);

	const timeRef = React.useRef();

	const overHandlerRef = React.useRef(overHandler);

	const startStatus = React.useRef(false);

	//倒计时
	const countDown = React.useCallback(() => {
		clearTimeout(timeRef.current);
		if (secondRef.current === 0) {
			if (startStatus.current) {
				overHandlerRef.current && overHandlerRef.current();
			}
			startStatus.current = false;
			return;
		}

		if (!refMounted.current) return;

		setSecond((m) => m - 1);

		secondRef.current--;

		if (secondRef.current === 30) {
			setVoice(true);
		}

		timeRef.current = setTimeout(() => {
			countDown();
		}, 1000);
	}, []);

	const timestampRef = React.useRef();

	React.useEffect(() => {
		refMounted.current = true;

		function visibilitychangeHandler() {
			if (document.visibilityState === 'visible') {
				if (timestampRef.current) {
					if (!refMounted.current) return;

					let second = new Date() - timestampRef.current;

					let restart = secondRef.current - parseInt(second / 1000);

					if (restart <= 0) restart = 0;

					setSecond(restart);

					secondRef.current = restart;

					countDown();
				}
			} else if (document.visibilityState === 'hidden') {
				timestampRef.current = new Date();

				if (timeRef.current) {
					clearTimeout(timeRef.current);
				}
			}
		}

		document.addEventListener('visibilitychange', visibilitychangeHandler);

		return () => {
			refMounted.current = false;

			document.removeEventListener('visibilitychange', visibilitychangeHandler);

			if (timeRef.current) {
				clearTimeout(timeRef.current);
			}
		};
	}, [countDown]);

	//开始
	const start = React.useCallback(
		(number) => {
			startStatus.current = true;

			setSecond(number);

			secondRef.current = number;

			countDown();
		},
		[countDown]
	);
	//结束
	const stop = React.useCallback(() => {
		secondRef.current = 0;

		setSecond(0);

		startStatus.current = false;
	}, []);

	const time = React.useMemo(() => {
		let d = parseInt(second / 60 / 60 / 24);
		let h = parseInt((second / 60 / 60) % 24);
		h = h < 10 ? '0' + h : h;
		let m = parseInt((second / 60) % 60);
		m = m < 10 ? '0' + m : m;
		let s = parseInt(second % 60);
		s = s < 10 ? '0' + s : s;
		return {
			day: d,
			hour: h,
			minutes: m,
			seconds: s
		};
	}, [second]);

	return { start, stop, voice, second, time };
};

//判断文字行数是否超过rowNumber
export const useShowMore = ({ rowsNumber, id, text, init }) => {
	const [isMore, setIsMore] = React.useState(init);

	React.useEffect(() => {
		if (!text) return;

		const ele = document.getElementById(id);

		if (!ele) return;

		const style = window.getComputedStyle(ele, null);

		const height = parseInt(style.height);

		const lineHeight = parseInt(style.lineHeight);

		setIsMore(height / lineHeight > rowsNumber);
	}, [id, rowsNumber, text]);

	return { isMore };
};

//获取图片大小
export const useImageSize = (url) => {
	const mounted = useRefMounted();

	const [size, setSize] = React.useState([0, 0]);

	React.useEffect(() => {
		if (!url) return;

		const img = document.createElement('img');

		img.addEventListener('load', (e) => {
			const { naturalHeight, naturalWidth } = e.target;

			if (!mounted.current) return;

			setSize([naturalWidth, naturalHeight]);
		});

		img.src = url;
	}, [url, mounted]);
	return size;
};

/**
 *
 *
 * @param {*}  endHandler  倒计时结束事件
 * @return {*}  { start ,time  } 开始倒计时 当前时间
 */
export const useTimeCountDown = (overHandler) => {
	const [time, setTime] = React.useState({
		day: 0,
		hour: 0,
		minutes: 0,
		seconds: 0
	});

	const end = React.useRef(null);

	const refMounted = React.useRef(false);

	const overHandlerRef = React.useRef(overHandler);

	const countDownAPI = React.useCallback(() => {
		if (!refMounted.current) return;

		let nowTime = dayjs();

		let day = end.current.diff(nowTime, 'days');
		let hour = end.current.diff(nowTime, 'hours') % 24;
		let minutes = end.current.diff(nowTime, 'minutes') % 60;
		let seconds = end.current.diff(nowTime, 'seconds') % 60;
		if (hour <= 0 && minutes <= 0 && seconds <= 0) {
			setTime({
				day: 0,
				hour: 0,
				minutes: 0,
				seconds: 0
			});

			overHandlerRef.current && overHandlerRef.current();

			return;
		}
		hour = hour >= 10 ? hour : `0${hour}`;
		minutes = minutes >= 10 ? minutes : `0${minutes}`;
		seconds = seconds >= 10 ? seconds : `0${seconds}`;

		setTime({
			day,
			hour,
			minutes,
			seconds
		});

		setTimeout(countDownAPI, 1000);
	}, []);

	const start = React.useCallback(
		(endtime) => {
			if (endtime) {
				end.current = endtime;
				countDownAPI();
			}
		},
		[countDownAPI]
	);

	React.useEffect(() => {
		refMounted.current = true;

		return () => {
			refMounted.current = false;
		};
	}, []);

	const over = end.current
		? time.day === 0 &&
		  time.hour === 0 &&
		  time.minutes === 0 &&
		  time.seconds === 0
		: true;

	return { start, time, over };
};

const notAnimationFrame = typeof window.requestAnimationFrame === 'undefined';
/**
 * requestAnimationFrame 定时器
 * @param {*} duration 间隔时间
 * @param {*} callback 回调函数
 * @param {*} options { immediate } 开始时是否立即执行
 * @returns
 */
export const useRaf = (
	duration,
	callback = () => {},
	options = {
		immediate: false
	}
) => {
	const rfaIdRef = React.useRef(null);
	const startRef = React.useRef(null);
	const eventRef = React.useRef(null);
	const duaRef = React.useRef(0);
	duaRef.current = duration;
	eventRef.current = callback;
	const immediate = options.immediate;

	const requestAnimationFrameFn = React.useCallback(() => {
		if (notAnimationFrame) {
			rfaIdRef.current = setInterval(() => {
				eventRef.current();
			}, [duration]);
		}
		const fn = (timestamp) => {
			if (!startRef.current) {
				startRef.current = timestamp;
			}

			if (timestamp - startRef.current > duaRef.current) {
				eventRef.current();
				startRef.current = timestamp;
			}
			rfaIdRef.current = requestAnimationFrame(fn);
		};

		rfaIdRef.current = requestAnimationFrame(fn);
	}, [duration]);

	const start = React.useCallback(() => {
		if (rfaIdRef.current) {
			return;
		}
		if (immediate) {
			eventRef.current();
		}
		requestAnimationFrameFn();
	}, [requestAnimationFrameFn, immediate]);

	const stop = React.useCallback(() => {
		if (notAnimationFrame) {
			clearInterval(rfaIdRef.current);
		}
		cancelAnimationFrame(rfaIdRef.current);
		startRef.current = undefined;
		rfaIdRef.current = null;
	}, []);

	React.useEffect(() => {
		return () => {
			stop();
		};
	}, [stop]);

	return {
		start,
		stop
	};
};

export function useDragHook({ nodeRef, onEnd, disabled, touchMove }) {
	const touchStartX = React.useRef(0); // 点击偏移量X
	const touchStartY = React.useRef(0); // 点击偏移量Y
	const endRef = React.useRef();

	const yRef = React.useRef(false);
	const xRef = React.useRef(false);
	endRef.current = onEnd;
	const [x, setX] = React.useState(0);
	const [y, setY] = React.useState(0);
	const startPoint = React.useRef();
	const isFirst = React.useRef(true);

	React.useEffect(() => {
		if (disabled) {
			return;
		}

		if (!nodeRef || !nodeRef.current) {
			return;
		}

		const node = nodeRef.current;

		const touchmove = (e) => {
			const { clientX, clientY, pageX, pageY } = e.targetTouches[0];
			setX(clientX - touchStartX.current);
			setY(clientY - touchStartY.current);

			const nowPoint = {
				x: pageX,
				y: pageY
			};

			const dis = {
				x: nowPoint.x - startPoint.current.x,
				y: nowPoint.y - startPoint.current.y
			};

			if (isFirst.current) {
				isFirst.current = false;
				if (Math.abs(dis.x) > Math.abs(dis.y)) {
					yRef.current = true;
				} else {
					xRef.current = true;
				}
			}
			touchMove && touchMove(e, xRef, yRef);
		};

		const touchend = () => {
			endRef.current && endRef.current();
			window.removeEventListener('touchmove', touchmove);
			window.removeEventListener('touchend', touchend);
		};

		const touchstart = (e) => {
			e.stopPropagation();
			const { clientX, clientY, pageX, pageY } = e.targetTouches[0];

			startPoint.current = {
				x: pageX,
				y: pageY
			};

			isFirst.current = true;
			yRef.current = false;
			xRef.current = false;

			touchStartX.current = clientX;
			touchStartY.current = clientY;

			window.addEventListener('touchmove', touchmove, {
				passive: false
			});
			window.addEventListener('touchend', touchend);
		};
		node.addEventListener('touchstart', touchstart);
		return () => {
			node.removeEventListener('touchstart', touchstart);
			window.removeEventListener('touchmove', touchmove);
			window.removeEventListener('touchend', touchend);
		};
	}, [nodeRef, disabled, touchMove]);

	return { x, setX, y, setY };
}

export const useVisibleChange = (callback) => {
	const fnRef = React.useRef();
	fnRef.current = callback;
	const handleVisibilityState = React.useCallback(() => {
		if (document.visibilityState === 'visible') {
			fnRef.current && fnRef.current();
		}
	}, []);
	React.useEffect(() => {
		document.addEventListener('visibilitychange', handleVisibilityState);
		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityState);
		};
	}, [handleVisibilityState]);
};

export const usePollingData = ({
	callback,
	duration = 30000,
	stopTime = 60000,
	immediate
}) => {
	const timeRef = React.useRef(new Date().getTime());
	const { start, stop } = useRaf(
		duration,
		() => {
			if (new Date().getTime() - timeRef.current <= stopTime) {
				callback && callback();
			}
		},
		{
			immediate: immediate
		}
	);

	React.useEffect(() => {
		start();
		const handleTouchStart = () => {
			timeRef.current = new Date().getTime();
		};
		window.addEventListener('touchstart', handleTouchStart, false);

		return () => {
			window.removeEventListener('touchstart', handleTouchStart, false);
		};
	}, [start]);

	const pollingStart = React.useCallback(() => {
		timeRef.current = new Date().getTime();
		start();
	}, [start]);

	return { start: pollingStart, stop };
};
